/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/focusableInput.error.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'focusableInput/error', exports: {} }; const exports = module.exports;

const Selectors = {
    CLEAR_BTN: '.fd-clearable-input__icon',
    ERROR: '.js-fcsbl-input-error',
    ERROR_MSG: '.js-fcsbl-input-error-msg',
    INPUT: '.js-fcsbl-input',
    LABEL: '.js-fcsbl-label',
    PASSWORD_TOGGLE: '.js-fcsbl-pw-toggle',
    WRAPPER: '.js-focsbl-input-holder',
}
const Styles = {
    ERROR: 'fcsbl-input__error',
    HAS_ERROR: 'fcsbl-input--has-error',
    HIDE: 'hide',
}
function toggleErrors(fields, show) {
    fields.forEach(({ $input, error }) => toggle($input, error, show));
}
function toggle($input, error, show) {
    const $errorElement = $input.siblings(Selectors.ERROR);
    $input.parent(Selectors.WRAPPER).toggleClass(Styles.HAS_ERROR, show);
    $input.siblings(Selectors.PASSWORD_TOGGLE).toggleClass(Styles.HIDE, show);
    $errorElement.children(Selectors.ERROR_MSG).text(error || '');
    $input.siblings(Selectors.CLEAR_BTN).toggleClass(Styles.HIDE, show);
    $errorElement.toggleClass(Styles.HIDE, !show);
    $input.siblings(Selectors.LABEL).toggleClass(Styles.ERROR, show);
    $input.toggleClass(Styles.ERROR, show);
}
export default {
    toggle,
    toggleErrors
};